import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getAccount } from '../../../Api'
import DownloadModal from '../../DownloadDr6/DownloadModal'
import downloadPurple from '../../SearchResults/images/DownloadSVG.svg'
import useStore from '../../StorePeople/Store'
import arrowRight from '././ListOfResults/images/arrowRight.svg'
import ExampleSearches from './ExampleSearches/ExampleSearches'
import Results from './ListOfResults/Results'
import arrowLeft from './ListOfResults/images/arrowLeft.svg'
import styles from './styles.module.css'

export default function SearchResults () {
  const {
    dataResults,
    queryStore,
    isQueryLoading,
    page,
    setPage,
    shouldRefetch,
    setShouldRefetch
  } = useStore()
  const {
    data: AccountData,
    isLoading,
    refetch
  } = useQuery('account', getAccount)
  const [calculatedCredits, setCalculatedCredits] = useState(0)
  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false)

  const dataType = 'people'
  const dataToDownload = dataResults?.data
  const queryToDownload = queryStore?.query
  const TOTAL_NUMBER_RECORDS = dataResults?.data?.num_found
  const RECORDS_PER_PAGE = 50
  const isPreviousDisabled = page <= 1
  const totalNumberOfPages = Math.ceil(TOTAL_NUMBER_RECORDS / RECORDS_PER_PAGE)
  const isNextDisabled = page >= totalNumberOfPages
  const [startIndex, setStartIndex] = useState(1)
  const [endIndex, setEndIndex] = useState(RECORDS_PER_PAGE)

  useEffect(() => {
    if (!AccountData?.data?.plans) return

    const plan = AccountData.data.plans.find(plan =>
      plan.id?.includes('people')
    )
    if (plan) {
      const credits =
        plan?.credits_allotted - AccountData?.data?.people_credits_used
      setCalculatedCredits(credits)
    }
  }, [AccountData])

  useEffect(() => {
    if (shouldRefetch) {
      // call refetch
      refetch()
      // reset the flag to false
      setShouldRefetch(false)
    }
  }, [shouldRefetch, refetch, setShouldRefetch])

  const toggleDownloadModal = () => {
    if (queryToDownload && !isQueryLoading) {
      setIsDownloadModalVisible(!isDownloadModalVisible)
    }
  }

  useEffect(() => {
    const newStartIndex = (page - 1) * RECORDS_PER_PAGE + 1
    const newEndIndex = Math.min(
      newStartIndex + RECORDS_PER_PAGE - 1,
      TOTAL_NUMBER_RECORDS
    )

    setStartIndex(newStartIndex)
    setEndIndex(newEndIndex)
  }, [page, RECORDS_PER_PAGE, TOTAL_NUMBER_RECORDS])

  const goToNextPage = () => {
    if (page < totalNumberOfPages) {
      setPage(page + 1)
    }
  }

  const goToPreviousPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const downloadStyle =
    isQueryLoading || !queryToDownload
      ? { cursor: 'not-allowed', opacity: 0.5 }
      : { cursor: 'pointer' }

  return (
    <section>
      <div
        className={styles.searchResultPeopleContainer}
        style={{}}
        // marginBottom: dataResults?.data ? '0px' : '26px'
      >
        <h1 className={styles.searchResultPeopleTitle}>Search results</h1>

        <div className={styles.searchResultPeopleFlexContainer}>
          <div className={styles.searchResultPeopleFlexGap}>
            <div>
              <span className={styles.searchResultPeopleTotalMatches}>
                Total available matches:
              </span>
              <span className={styles.searchResultPeopleTotalMatchesValue}>
                {dataResults?.data?.num_found
                  ? dataResults?.data?.num_found.toLocaleString('en-US')
                  : 'N/A'}
              </span>
            </div>
            <div>
              <span className={styles.searchResultPeopleRecordCredits}>
                Available record credits:
              </span>
              <span className={styles.searchResultPeopleRecordCreditsValue}>
                {isLoading
                  ? 'Loading...'
                  : AccountData?.data?.role === 'admin'
                  ? 'Admin'
                  : calculatedCredits ?? 'N/A'}
              </span>
            </div>

            <div>
              <span
                onClick={queryToDownload ? toggleDownloadModal : undefined}
                className={styles.searchResultPeopleDownloadLabel}
                style={downloadStyle}
              >
                Download
              </span>

              <img
                onClick={queryToDownload ? toggleDownloadModal : undefined}
                src={downloadPurple}
                alt='upload'
                style={downloadStyle}
                className={styles.searchResultPeopleDownloadIcon}
              />
            </div>
          </div>
          <div>
            {dataResults?.data ? (
              <div className={styles.searchResultPeoplePaginationContainer}>
                <span className={styles.searchResultPeopleShowingRecords}>
                  Showing records:
                </span>
                <span className={styles.searchResultPeopleShowingRecordsValue}>
                  {startIndex} - {endIndex}
                </span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    onClick={
                      !(isPreviousDisabled || isQueryLoading)
                        ? goToPreviousPage
                        : undefined
                    }
                    src={arrowLeft}
                    alt='Previous'
                    className={styles.searchResultPeopleArrow}
                    style={{
                      opacity: isPreviousDisabled || isQueryLoading ? 0.5 : 1
                    }}
                  />
                  <img
                    onClick={
                      !(isNextDisabled || isQueryLoading)
                        ? goToNextPage
                        : undefined
                    }
                    src={arrowRight}
                    alt='Next Page'
                    className={styles.searchResultPeopleArrow}
                    style={{
                      opacity: isNextDisabled || isQueryLoading ? 0.5 : 1
                    }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {dataResults?.data ? <Results /> : <ExampleSearches />}
      {isDownloadModalVisible && (
        <DownloadModal
          onClose={toggleDownloadModal}
          totalRecords={TOTAL_NUMBER_RECORDS}
          dataToDownload={dataToDownload}
          queryToDownload={queryToDownload}
          dataType={dataType}
        />
      )}
    </section>
  )
}
